import type { InjectionKey } from 'vue';

export interface AccordionItemRegistration {
    isActive: () => boolean;
    removeActive: () => void;
}

export interface AccordionContext {
    registerAccordionItem: (item: AccordionItemRegistration) => () => void;
    handleAllActives: () => void;
    emitChangeEvent: () => void;
    emitActiveChanged: (state: boolean) => void;
}

export const ACCORDION_CONTEXT_KEY: InjectionKey<AccordionContext> = Symbol('accordionContext');
